import React from "react";
import { BiPlay } from "react-icons/bi";
import { FaLock } from "react-icons/fa";
import { AiOutlineStar } from "react-icons/ai";
import { BsDot } from "react-icons/bs";

import "./VideoCard.scss";
import { MdKeyboardArrowRight } from "react-icons/md";

export default function VideoCard(props) {
  const { video } = props;
  return (
    <li className="custom_card video_card">
      <div className={`card_image_container video_thumbnail_container ${video.unlocked ? "" : "deactivate"}`}>{video.unlocked ? <BiPlay /> : <FaLock />}</div>
      <div className="card_info_container">
        <h6 className="video_title">{video.videoTitle}</h6>

        <div className="card_detail">
          <div className="rating_container">
            <AiOutlineStar />
            {video.rating}
          </div>
          <BsDot />
          <p>{video.videoLength} min</p>
        </div>
      </div>
      <MdKeyboardArrowRight className="right_arrow_icon" />
    </li>
  );
}
